class ReadMoreButton extends HTMLElement {
    constructor() {
      super();
      this.min = this.getAttribute("min");
      this.read_more = this.getAttribute("read-more");
      this.read_less = this.getAttribute("read-less");
      this.open = false;
      this.contentEl = this.querySelector('.collection-hero__description__read-more');
      this.labelEl = this.querySelector('.read-more-label');
      this.button = this.querySelector('button');

      if (this.contentEl.scrollHeight > this.contentEl.offsetHeight) {
        this.button.style.cssText = '';
      }

      setTimeout(() => {
        // Make it work in Shopify's admin
        if (this.contentEl.scrollHeight > this.contentEl.offsetHeight) {
          this.button.style.cssText = '';
        }
      }, 500)

      this.button.addEventListener('click', (event) => {
        this.open = !this.open;

        if (this.open) {
          this.style.setProperty('--collection-hero-description-lines', 1000);
          this.button.querySelector('svg').classList.add('t-rotate-90');
          this.labelEl.textContent = this.read_less;
        } else {
          this.style.setProperty('--collection-hero-description-lines', this.min);
          this.button.querySelector('svg').classList.remove('t-rotate-90');
          this.labelEl.textContent = this.read_more;
        }
      });
    }
  }

  customElements.define("read-more-button", ReadMoreButton);